import { useEffect, useState } from "react";
import { getRouteLang, USER_LANG_CHANGED_EVENT } from "../utils/language";

/**
 * [A15-02] Subskrypcja języka routingu — dla komponentów, które BUDUJĄ coś przy renderze
 * na podstawie języka (tablica tras w App.js) i muszą zostać przeliczone po jego zmianie.
 *
 * Nasłuchujemy dwóch sygnałów:
 *  - `USER_LANG_CHANGED_EVENT` — zmiana w TEJ karcie (emitowana przez `setUserLang`),
 *  - natywnego `storage` — zmiana w INNEJ karcie tej samej przeglądarki.
 *
 * Zwraca "pl" albo "en".
 */
export function useRouteLang() {
    const [lang, setLang] = useState(getRouteLang);

    useEffect(() => {
        const sync = () => setLang(getRouteLang());
        window.addEventListener(USER_LANG_CHANGED_EVENT, sync);
        window.addEventListener("storage", sync);
        return () => {
            window.removeEventListener(USER_LANG_CHANGED_EVENT, sync);
            window.removeEventListener("storage", sync);
        };
    }, []);

    return lang;
}

export default useRouteLang;
